import React from 'react';
import { CircularProgress } from '@material-ui/core';

const LoadingIndicator: React.FC = () => {
  return <CircularProgress size={60} color="secondary" />;
};

export default LoadingIndicator;
